import AdventureSquare from "./AdventureSquare";

export default class Adventure {
    id: string;
    begin: Date;
    complete: Date;
    firstSpace: number;
    squares: AdventureSquare[];
}